<ng-container>
  <app-setting-item [title]="title()" [subtitle]="tooltip()">
    <ng-template #view>
      @for(opt of value(); track opt) {
        <app-tag-badge>{{opt}}</app-tag-badge>
      } @empty {
        {{null | defaultValue}}
      }
    </ng-template>

    <ng-template #edit>
      <textarea rows="3" class="form-control"
                [appFormField]="fieldDirective.field()"
                [value]="textFieldValue()"
                (change)="onTextFieldChange($event)" [disabled]="disabled()">
      </textarea>
    </ng-template>

  </app-setting-item>
</ng-container>
